import React from "react";
import Backbutton from "../components/Backbutton";
import Forgotpasswordpage from "../components/forgotpassword/Forgotpasswordpage";

function ForgotPassword() {
    return (
        <>
            <Backbutton />
            <Forgotpasswordpage />
        </>
    );
}

export default ForgotPassword;
